import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Navbar } from './components/Navbar';
import ScrollQuiz from './components/ScrollQuiz';
import { Toaster } from './components/ui/toaster';
import LoginPage from './pages/LoginPage';
import MakeQuizPage from './pages/MakeQuizPage';
import QuizPage from './pages/QuizPage';
import { authStore } from './store/AuthStore';
import quizStore from './store/QuizStore';
import './styles/index.css';

const App: React.FC = () => {
  const [activeComponent, setActiveComponent] = useState<string>('Quizzes');

  // Show loading state while checking authentication
  if (authStore.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  // Show login page if user is not authenticated
  if (!authStore.user) {
    return <LoginPage />;
  }

  return (
    <>
      <Navbar
        activeComponent={activeComponent}
        setActiveComponent={setActiveComponent}
      />
      <Toaster />
      <div className="fullApp">
        <ToastContainer />
        {activeComponent === 'Quizzes' && (
          <QuizPage quizzes={quizStore.quizzes} />
        )}
        {activeComponent === 'GenerateQuestions' && <MakeQuizPage />}
        {activeComponent === 'ScrollQuiz' && <ScrollQuiz />}
      </div>
    </>
  );
};

export default observer(App);
